import { dashboardCookieName } from './dashboard-cookie-name'

export const resolveDashboard = (
  $cookies: {
    readonly get: LegacyCookiesService['get']
    readonly put: LegacyCookiesService['put']
  },
  $window: {
    readonly location: {
      hash: angular.IWindowService['location']['hash']
    }
  },
  $routeParams: {
    readonly orgUuid: string
  }
) => {
  'ngInject'

  if (!$cookies.get(dashboardCookieName)) {
    $cookies.put(dashboardCookieName, 'true', { path: '/Contrast' })
  }

  $window.location.hash = `/${$routeParams.orgUuid}/dashboard`
}

export const valueReportingRouteConfig = (
  $routeSegmentProvider: {
    readonly segment: LegacyRouteSegmentProvider['segment']
    readonly when: LegacyRouteSegmentProvider['when']
  },
  AuthOptionsProvider: {
    readonly buildSecureRouteConfiguration: LegacyAuthOptionsProvider['buildSecureRouteConfiguration']
  }
) => {
  'ngInject'

  $routeSegmentProvider.segment(
    'value-reporting',
    AuthOptionsProvider.buildSecureRouteConfiguration(
      // Intentionally not setting a templateUrl here
      // since accessing this route will redirect to the
      // main dashboard route instead. It does this in the
      // route resolver below, so the template is never needed.
      undefined,
      false,
      ['orgUuid'],
      {
        resolveDashboard
      }
    )
  )

  $routeSegmentProvider.when('/:orgUuid/value-reporting', 'value-reporting')
}
